import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {IServiceDisconnect} from '../interfaces/KKM/IServiceDisconnect';
import {EDisconnectReason} from '../Enums/DisconnectReason';
import {IKkm} from '../interfaces/payment/IKkm';
import {Typography} from '@mui/material';

interface IStatusIconProps {
    kkm: IKkm;
    showText?: boolean;
    disabledByClientOnly?: boolean;
}

const StatusIcon: React.FC<IStatusIconProps> = ({kkm, showText, disabledByClientOnly}) => {
    const disabledByClient = kkm.service_disconnect?.find(
        (item: IServiceDisconnect) => item.disconnect_reason_id === EDisconnectReason.DisabledByClient,
    );
    const notRent = !kkm.service_rent?.length;

    if (disabledByClient) {
        return (
            <>
                <Tooltip title="Приостановлено по заявлению клиента">
                    <PauseCircleOutlineIcon color="disabled" />
                </Tooltip>
                {showText ? (
                    <Typography variant="body2" color="gray">
                        Приостановлено
                    </Typography>
                ) : null}
            </>
        );
    }

    if (disabledByClientOnly) {
        return <></>;
    }

    if (kkm.blocked_by_billing) {
        return (
            <>
                <Tooltip
                    title={
                        <>
                            Отрицательный баланс.
                            <br />
                            Услуга может быть заблокирована
                        </>
                    }
                >
                    <BlockIcon color="error" />
                </Tooltip>
                {showText ? (
                    <Typography variant="body2" color="error">
                        Отрицательный баланс
                    </Typography>
                ) : null}
            </>
        );
    }

    if (kkm.status === 1 && notRent) {
        return (
            <>
                <Tooltip title="Тариф не подключён">
                    <BlockIcon color="disabled" />
                </Tooltip>
                {showText ? (
                    <Typography variant="body2" color="gray">
                        Тариф не подключён
                    </Typography>
                ) : null}
            </>
        );
    }

    if (kkm.status === 1) {
        return (
            <>
                <Tooltip title="Услуга подключена">
                    <CheckCircleOutlineIcon color="success" />
                </Tooltip>
                {showText ? (
                    <Typography variant="body2" color="green">
                        Услуга подключена
                    </Typography>
                ) : null}
            </>
        );
    }

    return (
        <>
            <Tooltip title="Услуга не активна">
                <CheckCircleOutlineIcon color="disabled" />
            </Tooltip>
            {showText ? (
                <Typography variant="body2" color="gray">
                    Услуга не активна
                </Typography>
            ) : null}
        </>
    );
};

export default StatusIcon;
